import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import PeopleIcon from '@mui/icons-material/PeopleOutlineTwoTone';
import PlanIcon from '@mui/icons-material/PolicyOutlined';
import React, {useEffect, useState} from 'react';
import SidebarListItem from './SidebarListItem';
import routePath, {Routes} from '@account/utils/route';
import {Collapse, List, styled} from '@mui/material';
import {lightGrey} from '@account/styles';
import {useParams} from 'react-router-dom';

const StyledList = styled(List)({
  borderBottom: `solid 1px ${lightGrey}`,
});

const OrganizationSidebar = () => {
  const {orgId} = useParams();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(true), [setOpen]);

  return orgId !== 'undefined' ? (
    <Collapse in={open}>
      <StyledList disablePadding>
        <SidebarListItem
          nested
          to={routePath(Routes.ORG_GENERAL, {orgId})}
          icon={<InfoIcon color="disabled" fontSize="small" />}
          text="General"
          id="organization-general"
          exact
        />

        <SidebarListItem
          nested
          to={routePath(Routes.ORG_USERS, {orgId})}
          icon={<PeopleIcon color="disabled" fontSize="small" />}
          text="Users"
          id="organization-users"
          exact
        />

        <SidebarListItem
          nested
          to={routePath(Routes.ORG_SUBORGS, {orgId})}
          icon={<AccountTreeOutlinedIcon color="disabled" fontSize="small" />}
          text="Sub Organizations"
          id="organization-subOrgs"
          exact
        />

        <SidebarListItem
          nested
          to={routePath(Routes.ORG_PLANS, {orgId})}
          icon={<PlanIcon color="disabled" fontSize="small" />}
          text="Plans"
          id="organization-plans"
        />
      </StyledList>
    </Collapse>
  ) : (
    <p>not found </p>
  );
};

export default OrganizationSidebar;
